import { useUserRightUtil } from '../../../util/rights';
import { GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL } from '../api/Constants';
import { GroupAPI } from '../api/GroupAPI';

/**
 * Get and fetch group from workspaceId
 * @param workspaceId
 * @returns [group, loading, error]
 * 
 * @usage
´´´ts
const { data:groups, isLoading, error} = useGroupByWorkspaceId(workspaceId)
´´´
 */
export function useGroupsByWorkspaceId(workspaceId: string) {
  const rightsUserUtil = useUserRightUtil();
  const right = rightsUserUtil.canAddWorkspaceGroups(workspaceId);
  const { data, isLoading, error } = GroupAPI.useGetGroupsByWorkspaceIdQuery(
    workspaceId,
    {
      pollingInterval: GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL,
      skip: !workspaceId || !right,
    }
  );
  return { data: data?.entities.groups, isLoading, error };
}
